import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { FollowupActionStatus } from '@/models/form_submission'
import { isArray, sortBy } from 'lodash'
import { useGetTagsQuery } from '@/api/tags'

export default {
  computed: {
    ...mapState({
      locations: (state) => state.locations.all,
    }),
    tagOptions() {
      const { data: tagOptions } = useGetTagsQuery()

      if (!tagOptions.value) {
        return []
      }

      const values = new Set([...tagOptions.value.map((tag) => tag.name)])
      return [...values].map((tag) => ({ name: tag, id: tag }))
    },
    ...mapGetters({
      dateRange: 'formSubmissionsFilters/getDateRange',
      getDateRange: 'formSubmissionsFilters/getDateRange',
      getAllVisibleForms: 'forms/getAllVisible',
      getSubjectSearchIds: 'formSubmissionsFilters/getSubjectSearchIds',
      isFiltersVisible: 'formSubmissionsFilters/getFilterAsideVisibility',
    }),
    dateRangeStart() {
      return this.getDateRange.start ? moment(this.getDateRange.start) : null
    },
    dateRangeEnd() {
      return this.getDateRange.end ? moment(this.getDateRange.end) : null
    },
    dateRangeLabel() {
      return this.hasDateRange
        ? `${this.dateRangeEnd.diff(this.dateRangeStart, 'days') + 1} dates selected`
        : 'Showing all dates'
    },
    hasDateRange() {
      return this.dateRangeStart !== null && this.dateRangeEnd !== null
    },
    formNameOptions() {
      const options = []
      const groupedForms = {}

      for (const form of this.getAllVisibleForms) {
        if (form.accessGrants.length > 0) {
          const categoryName = form.category?.name ?? 'Uncategorized'
          if (!isArray(groupedForms[categoryName])) {
            groupedForms[categoryName] = []
          }
          groupedForms[categoryName].push(form)
        }
      }

      const sortedGroupedForms = Object.keys(groupedForms)
        .sort((a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1))
        .reduce((grouped, key) => Object.assign(grouped, { [key]: groupedForms[key] }), {})

      for (const [categoryName, forms] of Object.entries(sortedGroupedForms)) {
        options.push({ header: true, text: categoryName })
        for (const form of sortBy(forms, [(form) => form.name.toLowerCase()])) {
          options.push(form)
        }
      }

      return options
    },
    getFormActions() {
      return [
        { id: FollowupActionStatus.None, name: 'None' },
        {
          id: FollowupActionStatus.RequiredAndUnassigned,
          name: 'Required and unassigned',
        },
        {
          id: FollowupActionStatus.RequiredAndAssigned,
          name: 'Required and assigned',
        },
        { id: FollowupActionStatus.Completed, name: 'Completed' },
      ]
    },
  },
  methods: {
    ...mapActions({
      showFiltersAside: 'formSubmissionsFilters/showAside',
      hideFiltersAside: 'formSubmissionsFilters/hideAside',
    }),
  },
}
